import { Controller } from "@hotwired/stimulus"
import { DragDropManager } from "@dnd-kit/dom"
import { Sortable } from "@dnd-kit/dom/sortable"
import {RestrictToVerticalAxis} from '@dnd-kit/abstract/modifiers';

// Connects to data-controller="drag-drop"
export default class extends Controller {
  static targets = ["element"]

  connect() {
    this.manager = new DragDropManager({
      modifiers: [RestrictToVerticalAxis]
    })

    this.elementTargets.forEach((element, index) => {
      new Sortable({ id: element.id, index, element }, this.manager)
    })
  }
}